import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import ExtendContract from './ExtendRecurringInvoice';
import ExtendRecurringInvoice from './ExtendRecurringInvoice';
export const ShowRecurringInvoice = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendRecurringInvoice
        row={{ id, onUpdate: () => {}, onDelete: () => {} }}
        onDelete={() => navigate('/recurring-invoices')}
      />
    </Box>
  );
};
